const r = ({ plugins: o = [] }) => {
  const s = /* @__PURE__ */ new Map();
  return o.forEach((e) => {
    const n = e();
    s.set(n.name, n);
  }), {
    /**
     * Get all extensions with the given name from registered plugins
     */
    getSpecificationExtensions: (e) => {
      const n = [];
      for (const i of s.values())
        for (const t of i.extensions)
          t.name === e && n.push(t);
      return n;
    }
  };
};
export {
  r as createPluginManager
};
